export default __webpack_public_path__ + "media/icons/info-grey-de6a30c9.svg";